import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromPhotos from '../actions/photos.actions';
import { PhotosService } from './photos.service';

@Injectable()
export class PhotosEffects {

     loadPhotos$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromPhotos.LOAD),
        switchMap((action: fromPhotos.Load) =>
            this.photosService.getCorrespondencePhotos(action.payload.dossier_volgnummer).pipe(
                map((resultaat) => resultaat.data),
                map((payload: fromPhotos.LoadSuccess) => new fromPhotos.LoadSuccess({
                    photos: payload,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                })),
                catchError((errors) => of(new fromPhotos.LoadError({
                    errors: errors,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions,
        private photosService: PhotosService,
    ) {}
}
